module.exports = __webpack_public_path__ + "img/view-off.69921931.svg";